module.exports = __webpack_public_path__ + "media/src/images/icons/icons8-agreement-9036c1145b2ee27537593fe13a5e08c9.png";